<pbc-filter [config]="BesichtigungsStatiFilterConfig" [filter]="besichtigungsStati.filter$ | async" (filterChange)="besichtigungsStati.filter$.next($event)"></pbc-filter>
